/** Empty same-origin API base — nginx/Vite proxy to FreeMusiers. */
export const API_BASE = '';
